import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  unitPriceList: [],
  group: undefined,
  loading: false,
  total: 0,
  error: '',
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { group, data, total, filteredTotal } = payload;

  return {
    ...state,
    unitPriceList: data,
    group,
    total,
    filteredTotal,
    loading: false,
  };
}

function onLoadError(state, { payload }) {
  return {
    ...initState,
    error: payload.error,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_ERROR]: onLoadError,
  [actions.CLEAR_STORE]: onClearStore,
});
